import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/about.scss";

function About() {
  return (
    <main className="about-page">
      <header className="about-page__header">
        <p className="about-page__eyebrow">Our story</p>
        <h1>Made for the long way around.</h1>
        <p className="about-page__lede">
          {siteConfig.brandName} makes dependable clothing for days that move
          between the city, the coast, and the trail.
        </p>
      </header>

      <figure className="about-page__hero">
        <img
          src="/img/about-workshop.webp"
          alt={`${siteConfig.brandName} outerwear being prepared in the workshop`}
        />
      </figure>

      <section className="about-page__story" aria-labelledby="about-story-title">
        <div className="about-page__section-heading">
          <p className="about-page__eyebrow">Why we make</p>
          <h2 id="about-story-title">Useful things, thoughtfully made.</h2>
        </div>
        <div className="about-page__copy">
          <p>
            We started with a simple idea: outdoor clothing should feel as
            natural on a morning walk as it does on a weekend away. Our pieces
            borrow the utility of classic trail gear, then refine the shape,
            fabric, and finish for everyday wear.
          </p>
          <p>
            Every collection is built slowly. We choose durable materials,
            practical details, and easy silhouettes that earn their place in a
            wardrobe. The result is clothing designed to be worn often, cared
            for, repaired, and passed along.
          </p>
        </div>
      </section>

      <section className="about-page__field-notes" aria-label="Our approach">
        <figure className="about-page__field-image">
          <img
            src="/img/about-coast.webp"
            alt={`${siteConfig.brandName} field jacket worn on a coastal walk`}
          />
        </figure>
        <div className="about-page__field-copy">
          <p className="about-page__eyebrow">Field notes</p>
          <blockquote>
            “Good design leaves room for the person wearing it—and for whatever
            the day becomes.”
          </blockquote>
          <p>
            We test fit, movement, storage, and comfort in the places our
            clothing is meant to go. Nothing is added without a reason, and
            nothing is considered finished until it feels effortless to use.
          </p>
        </div>
      </section>

      <section className="about-page__values" aria-labelledby="about-values-title">
        <div className="about-page__section-heading">
          <p className="about-page__eyebrow">Our principles</p>
          <h2 id="about-values-title">Built around the essentials.</h2>
        </div>
        <div className="about-page__value-grid">
          <article>
            <span>01</span>
            <h3>Purpose first</h3>
            <p>Details are considered for comfort, movement, and daily use.</p>
          </article>
          <article>
            <span>02</span>
            <h3>Better materials</h3>
            <p>We favor durable fabrics that soften and improve with wear.</p>
          </article>
          <article>
            <span>03</span>
            <h3>Fewer, lasting pieces</h3>
            <p>Seasonal color meets enduring shapes you can return to.</p>
          </article>
        </div>
      </section>

      <section className="about-page__closing">
        <p className="about-page__eyebrow">Keep exploring</p>
        <h2>Ready for wherever you are headed.</h2>
        <Link to="/shop" className="about-page__button">
          Shop the collection
        </Link>
      </section>
    </main>
  );
}

export default About;
